import { useDnDItem } from './useDnDItem';

interface ItemWithDnD {
  type: string;
  id: string | number;
  _index?: number;
}

interface useDnDItemProps<T extends ItemWithDnD> {
  item: T;
  selectedRows: FolderManagerItem[];
  overId: string | number | undefined | null;
  thumbnailUrl?: string;
}

export const useDnDSortableItem = <T extends ItemWithDnD>(props: useDnDItemProps<T>) =>
  useDnDItem({ ...props, sortable: true });
